import CryptoJS from "../libs/cryptoJS"

export function encrypt(param, keys, isSandbox) {
  var aesMsg = []
  var aesKey = isSandbox ? "0269bd8009164afc" : "2Wozy2aksie1puXU"
  keys.forEach(function(key) {
    aesMsg.push(key + "=" + (param[key] || ""))
  })
  aesMsg = aesMsg.join("&")
  var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Latin1.parse(aesMsg), CryptoJS.enc.Latin1.parse(aesKey), {
    padding: CryptoJS.pad.ZeroPadding,
    iv: CryptoJS.enc.Latin1.parse(aesKey),
    mode: CryptoJS.mode.ECB
  }).ciphertext.toString(CryptoJS.enc.Hex)
  return {
    encrypt_msg: encrypted,
    msg_len: aesMsg.length
  }
}
